import React from "react";

const WhoShouldApply = ({ data }) => {
  if (!data) return null;

  return (
    <section className="bg-white py-sp-100 sm:py-20">
      <div className="container px-3">
          <h2 className="text-darkBlack text-heading2 sm:text-2xl font-medium mb-3">
            {data.heading}
          </h2>
          <p className="text-darkBlack text-base2 sm:text-sm mb-4">
            {data.subHeading}
          </p>

          <div className="bg-white px-3 py-4 sm:p-3 border border-[#E5E7EB] rounded-2xl mb-6">
            <div className="flex flex-col gap-1">
              {data.points.map((point, index) => (
                <div key={index} className="flex items-start gap-1 pb-xsp">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="shrink-0">
                    <circle cx="12" cy="12" r="10" fill="#4A9447" />
                    <path d="M8.5 12.5l2.5 2.5 5-5" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className="text-darkBlack text-base sm:text-sm">
                    {point}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#FFF8E5] border border-[#E09E04] rounded-xl px-3 py-1 flex items-center gap-1">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="shrink-0 text-[#E3A003]">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
              <path d="M12 8v4M12 16h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <p className="text-[#6F6F6F] text-xs">
              {data.infoText}
            </p>
          </div>
        </div>
    </section>
  );
};

export default WhoShouldApply;
